import { useMemo } from 'react';
import { PeriodicityTypes } from '@hungryroot/rest';
import { useCustomerPeriodicities } from '@hungryroot/rest-hooks';

export { PeriodicityTypes };

export function useProductPeriodicityMap() {
  const { data, isLoading } = useCustomerPeriodicities();

  const memoizedProductCustomerPeriodicitiesMap = useMemo(() => {
    const periodicitiesMap = new Map<number, PeriodicityTypes>();

    if (data?.results?.length) {
      for (let periodicity of data?.results) {
        periodicitiesMap.set(periodicity.product, periodicity.periodicity);
      }
    }

    return periodicitiesMap;
  }, [data]);

  return {
    data: memoizedProductCustomerPeriodicitiesMap,
    isLoading,
  };
}
